import { render, staticRenderFns } from "./ConcludedCourses.vue?vue&type=template&id=c95b10c8&"
import script from "./ConcludedCourses.vue?vue&type=script&lang=js&"
export * from "./ConcludedCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports